import { IProduct } from '@kizi/comparator-core';
import { Div, DivProps } from '@kizi/core-components';
import { IconV2 as Icon } from '@kizi/shared-components';
import React, { MouseEventHandler } from 'react';

function formatUsps(usps: object): IProduct['usps'] {
  return Object.keys(usps).length
    ? Object.entries(usps).map((usp) => {
        const { content, type } = usp[1];

        return {
          text: content,
          type: type === 'con' ? 'warning' : type,
        };
      })
    : [];
}

export interface ProductUspsProps extends DivProps {
  data?: IProduct['usps'] | object;
  onItemClick?: MouseEventHandler;
  showConsPros?: boolean;
  showWarnings?: boolean;
  containerProps?: object;
}

export const ProductUsps = ({
  data,
  onItemClick,
  showConsPros = true,
  showWarnings = true,
  containerProps = {},
  ...restProps
}: ProductUspsProps): JSX.Element => {
  if (!data) return <></>;

  return (
    <>
      {(Array.isArray(data) ? data : formatUsps(data))
        .filter((usp) => {
          if (showConsPros === false) {
            return usp.type === 'warning';
          } else if (showWarnings === false) {
            return usp.type !== 'warning';
          } else {
            return usp;
          }
        })
        .map(({ text, type }, index) => {
          let icon = 'green-check';

          if (type === 'sun') {
            icon = 'sunny';
          }

          if (type === 'warning') {
            icon = 'small-alert';
          }

          if (type === 'con') {
            icon = 'small-cancel';
          }

          if (type === 'cashback') {
            icon = 'wallet';
          }

          return (
            <Div
              alignItems="center"
              display="flex"
              key={`usp-${index}`}
              css={containerProps}
            >
              <Div
                display="flex"
                variant={type === 'cashback' ? 'cashbackIcon' : ''}
              >
                <Icon
                  height={type === 'cashback' ? 20 : 28}
                  mr={type === 'cashback' ? 2 : 1}
                  ml={type === 'cashback' ? 1 : 0}
                  my="auto"
                  name={icon}
                  width={type === 'cashback' ? 20 : 28}
                  fill={type === 'sun' ? '#FFA617' : undefined}
                />
              </Div>
              <Div
                display="flex"
                alignItems="center"
                onClick={onItemClick}
                variant={type === 'cashback' ? 'cashbackText' : 'productUsp'}
                dangerouslySetInnerHTML={{ __html: text }}
                {...restProps}
                {...(type === 'cashback'
                  ? { css: { textDecoration: 'unset' } }
                  : {})}
              />
            </Div>
          );
        })}
    </>
  );
};
